import {map} from 'rxjs/operators';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import {resultsQueryToAPI} from '../../helpers';
import type * as Types from '../filters-and-columns/types';
import * as Models from './models';
import type * as Constants from './constants';

export interface ResultsQuery {
    columns: string; // Column ids separated by commas, e.g. `name,group,age`
    filters: {[filterId: string]: string};
    sortBy: string;
    order: Constants.SortOrder;
    limit: number;
    offset: number;
    kind: Types.FiltersAndColumnsKind;
    institutionId: string;
}

export const filterResults = (query: ResultsQuery) => {
    return RESTClient.getAuthenticatedObservable('v2/filter/results', resultsQueryToAPI(query)).pipe(
        map(results => {
            return Models.Results.fromAPI(results);
        }),
    );
};
